// JsFromRoutes CacheKey abcffaf9395cdfa09a54b0da1f924974
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  dashboard: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deals_reporting/dashboard'),
}
